import { render } from "./Teaching.vue?vue&type=template&id=7b14f56f"
import script from "./Teaching.vue?vue&type=script&lang=ts"
export * from "./Teaching.vue?vue&type=script&lang=ts"

import "./Teaching.vue?vue&type=style&index=0&id=7b14f56f&lang=scss"
script.render = render

export default script